export const initialState = {
  step: 0,
  isOpenModal: false,
  funcionalidades: [],
  funcionalidadesSelecionadas: [],
  isVincular: false,
  isEditar: false,
  isLoading: false,
  vincular: {
    usuarios: [],
    usuariosSelecionados: []
  },
  dadosPrincipais: {
    id: null,
    nome: '',
    empresas: [],
    indicadores: [],
    optionsEmpresas: [],
    optionsIndicadores: []
  },
  isAdmin: false,
  isPermanentRule: false
};

export const mutations = {
  nextStep(state) {
    state.step++;
  },
  backStep(state) {
    state.step--;
  },
  updateIsVincular(state, payload) {
    state.isVincular = payload;
  },
  updateIsEditar(state, payload) {
    state.isEditar = payload;
  },
  updateId(state, payload) {
    state.dadosPrincipais.id = payload;
  },
  updateStep(state, payload) {
    state.step = payload;
  },
  openModal(state) {
    state.isOpenModal = true;
  },
  closeModal(state) {
    state.isOpenModal = false;
  },
  updateUsuarios(state, payload) {
    state.vincular.usuarios = payload;
  },
  updateUsuariosSelecionados(state, payload) {
    state.vincular.usuariosSelecionados = payload;
  },
  resetState(state) {
    const model = JSON.parse(JSON.stringify(initialState));
    state.dadosPrincipais = model.dadosPrincipais;
    state.funcionalidadesSelecionadas = model.funcionalidadesSelecionadas;
    state.isVincular = model.isVincular;
    state.isEditar = model.isEditar;
    state.vincular = model.vincular;
    state.isAdmin = model.isAdmin;
  },
  updateLoading(state, payload) {
    state.isLoading = payload;
  },
  updateNome(state, payload) {
    state.dadosPrincipais.nome = payload;
  },
  updateEmpresas(state, payload) {
    state.dadosPrincipais.empresas = payload;
  },
  updateIndicadores(state, payload) {
    state.dadosPrincipais.indicadores = payload;
  },
  updateOptionsEmpresas(state, payload) {
    state.dadosPrincipais.optionsEmpresas = payload;
  },
  updateOptionsIndicadores(state, payload) {
    state.dadosPrincipais.optionsIndicadores = payload;
  },
  updateFuncionalidades(state, payload) {
    state.funcionalidades = payload;
  },
  updateFuncionalidadeSelecionada(state, payload) {
    state.funcionalidadesSelecionadas = state.funcionalidadesSelecionadas.map(tela => {
      if (tela.tela === payload.tela) {
        tela.funcionalidades = payload.funcionalidades;
      }

      return { ...tela };
    });
  },
  updateFuncionalidadesSelecionadas(state, payload) {
    state.funcionalidadesSelecionadas = payload;
  },
  updateIsAdmin(state, payload) {
    state.isAdmin = payload;
  },
  updateIsPermanentRule(state, payload) {
    state.isPermanentRule = payload;
  }
};

export const actions = {
  updateModal(context, payload) {
    context.commit('updateStep', 0);
    context.commit('resetState');
    if (!payload) {
      context.commit('closeModal');
    } else {
      context.commit('openModal');
    }
  },
  async updateOptions(context) {
    try {
      const [indicadores, empresas] = await Promise.all([R.Enum.getEnum('indicadores'), R.Empresa.todas()]);

      context.commit('updateOptionsEmpresas', empresas.data);
      context.commit('updateOptionsIndicadores', indicadores.data);
    } catch (e) {
      console.error(e);
    }
  },
  async updateOptionsFuncionalidades(context) {
    try {
      const { data } = await R.Enum.getEnum('obter-tela-funcionalidades');

      context.commit('updateFuncionalidades', data);
    } catch (e) {
      console.error(e);
    }
  }
};

export const getters = {
  isFirstTab: state => {
    return state.step === 0;
  },
  isLastTab: state => {
    return state.step === 2;
  },
  isFirstTabInvalid: state => {
    return Utils.isEmptyString(state.dadosPrincipais.nome);
  },
  isVincularMode: state => {
    return state.isVincular;
  },
  usuariosOptions: state => {
    return state.vincular.usuarios.map(usuario => ({
      key: usuario.id,
      title: usuario.nome,
      regraUsuario: usuario.regraUsuario
    }));
  },
  buildVMO: state => byScreen => {
    const tela = Object.values(state.funcionalidades).find(telas => telas.tela.toLowerCase() === byScreen.toLowerCase());

    if (!tela) return [];

    const model = tela.funcionalidades.map(funcionalidade => {
      let defaultValue;

      if (tela.tela === 'Regras de Usuário' && (!state.isVincular || !state.isEditar)) {
        defaultValue = false;
      } else {
        defaultValue = '';
      }

      return {
        [funcionalidade]: defaultValue
      };
    });

    return Utils.arrayToObject(model);
  },
  funcionalidadesMarcadas: state => {
    // Retorna apenas as funcionalidades marcadas como true ou ''(string vazia)
    let funcionalidadesDisponiveis = state.funcionalidadesSelecionadas;

    if (!state.isAdmin && (!state.isVincular || !state.isEditar)) {
      funcionalidadesDisponiveis = state.funcionalidadesSelecionadas.filter(funcionalidade => funcionalidade.tela !== 'Regras de Usuário' && (!state.isVincular) && !state.isAdmin);
    }

    return funcionalidadesDisponiveis.map(funcionalidade =>
      ({
        tela: funcionalidade.tela,
        funcionalidades: Object.entries(funcionalidade.funcionalidades).map(item => (item[1] === '' || item[1] === true) ? item[0] : null).filter(item => !!item)
      }));
  }
};

export default {
  state: () => {
    const model = JSON.parse(JSON.stringify(initialState));
    return model;
  },
  mutations: {
    ...mutations
  },
  actions: {
    ...actions
  },
  getters: {
    ...getters
  }

};
